import { createIcon } from './utils/createIcon.js';

export default createIcon({
  paths: [
    'M8.9 12.4v-.3c-.1-.7.1-1.5.8-2.2.6-.7.9-1.2.9-1.8 0-.7-.4-1.1-1.2-1.1-.5 0-1 .2-1.3.4l-.4-.9c.4-.3 1.2-.5 1.9-.5 1.5 0 2.2.9 2.2 1.9 0 .9-.5 1.5-1.1 2.3-.7.7-.9 1.2-.8 1.9v.3h-1zM8.6 14.3c0-.5.3-.8.8-.8s.8.3.8.8-.3.8-.8.8-.8-.4-.8-.8z',
    'M9.5 4c3.584 0 6.5 2.916 6.5 6.5S13.084 17 9.5 17 3 14.084 3 10.5 5.916 4 9.5 4zm0-1C5.375 3 2 6.375 2 10.5S5.375 18 9.5 18s7.5-3.375 7.5-7.5S13.625 3 9.5 3z',
  ],
  height: 20,
  width: 20,
});
